import { createClient } from '@supabase/supabase-js'
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://djfjbgfzumymaeszlaxw.supabase.co'
const supabaseKey = process.env.REACT_APP_SUPABASE_KEY || 'sb_publishable_CrLSEftX_bbiubFNSjiCDg_LIC8dC_Z'
export const supabase = createClient(supabaseUrl, supabaseKey)

// Faz um fetch anexando automaticamente o token de sessão do usuário
// logado (Authorization: Bearer <token>). Usado em todas as chamadas ao
// backend que exigem identificar o usuário — sem isso, o backend responde
// 401 (endpoints protegidos contra acesso por terceiros que apenas
// conheçam o UUID de outra conta).
export async function fetchAutenticado(url, options = {}) {
  const { data: { session } } = await supabase.auth.getSession()
  const headers = { ...(options.headers || {}) }
  if (session?.access_token) {
    headers['Authorization'] = `Bearer ${session.access_token}`
  }
  return fetch(url, { ...options, headers })
}
